import { useCallback, useEffect, useState } from 'react'
import { Placement, TooltipInstance, TooltipOptions } from 'bootstrap'

function placementAuto(this: TooltipInstance<TooltipOptions>, tooltip: HTMLElement, trigger: Element): Placement {
  const top = trigger.getBoundingClientRect().top
  return top > 300 ? 'top' : 'bottom'
}

const tooltipOptions: TooltipOptions = {
  html: false,
  container: 'main',
  trigger: 'hover focus',
  placement: placementAuto,
  template:
    '<div class="tooltip tooltip--white" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>'
}

export const hideTooltips = (): void => void $('[aria-describedby]').tooltip('hide')

// Hide all tooltips on scroll, because they get misaligned. Last "true" ensures that any scroll-event in any container is captured
window.addEventListener('scroll', hideTooltips, true)
// Hide other tooltips when opening a new tooltip. Makes focus feel more natural
$(window).on('show.bs.tooltip', hideTooltips)

export const useTooltip = <T extends HTMLElement>(tooltipText?: string): ((el: T | null) => void) => {
  const [el, setEl] = useState<T | null>(null)

  useEffect(() => {
    if (!el) {
      return
    }
    el.tabIndex = tooltipText ? 0 : -1
    el.title = tooltipText ?? ''
    if (tooltipText) {
      $(el).tooltip(tooltipOptions)
      if ($(el).is(':hover')) {
        $(el).tooltip('show')
      }
    }
    el.addEventListener('click', hideTooltips)
    return () => {
      $(el).tooltip('destroy')
      el.removeEventListener('click', hideTooltips)
    }
  }, [el, tooltipText])

  return useCallback((el: T | null) => {
    if (el) {
      setEl(el)
    }
  }, [])
}
